/* eslint-disable @typescript-eslint/no-explicit-any */
import Button from '@/components/Button';
import LoadingSpin from '@/components/Button/LoadingSpin';
import Card from '@/components/Card';
import Container from '@/components/Container';
import SubContainer from '@/components/Container/SubContainer';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import Tabs from '@/components/ui/tabs';
import { SearchSkeleton } from './loading';
import { useSearch } from './hooks/useSeach';
import { useUtils } from './hooks/useUtils';

export const SearchPage = () => {
  const {
    loading,
    loadingMore,
    search,
    fetchSearch,
    loadMoreData,
    showMoreButton,
    tabs,
    setTabs,
    filteredData,
    setSearch,
    firstTime,
    searchPage,
  } = useSearch();

  const { normalizeResource, getLink } = useUtils();

  const renderFilter = () => {
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter') {
        fetchSearch(false);
      }
    };

    return (
      <div className="col-span-12">
        <div>
          <Label className=" text-left">
            <p className=" mb-sh-30 text-sh-md font-bold">{searchPage?.title || 'Search'}</p>
          </Label>
          <Input
            type="search"
            name="search"
            value={search}
            placeholder="Enter your search"
            onChange={(event) => setSearch(event.target.value)}
            onKeyDown={handleKeyDown}
            className="w-full"
          />
        </div>

        <Button className="!mt-sh-30" onClick={() => fetchSearch(false)}>
          {searchPage?.searchBtn || 'Search'}
        </Button>
      </div>
    );
  };

  const renderContent = () => {
    return filteredData?.map((item: any) => {
      const normalizeItem = normalizeResource(item);

      const { title, description, thumbnail, author, type, duration, slug, typename } = normalizeItem || {};
      return (
        <div key={slug} className=" col-span-4">
          <Card
            title={title || ''}
            description={description || ''}
            author={author || ''}
            link={getLink(normalizeItem, typename)}
            tags={
              <DefaultContentTemplateTags
                tags={[type?.toString() || '']}
                className="!mb-2 !mt-0"
                duration={duration || undefined}
              />
            }
            image={{
              url: thumbnail?.data?.attributes?.url || '',
              alternativeText: thumbnail?.data?.attributes?.alternativeText || '',
            }}
          />
        </div>
      );
    });
  };

  return (
    <Container>
      <SubContainer className="mt-sh-60 grid grid-cols-subgrid lg:col-start-3 lg:col-end-11">
        {renderFilter()}
      </SubContainer>
      {!firstTime && (
        <SubContainer className="mt-sh-30 grid grid-cols-subgrid lg:col-start-3 lg:col-end-11">
          <h2 className="col-span-4 text-sh-md font-bold">{searchPage?.yourResultsTitle || 'Your results'}</h2>
        </SubContainer>
      )}

      {!firstTime && (
        <SubContainer className="flex justify-center">
          <div className=" grow">
            <Tabs
              tabs={tabs}
              setTabs={(newTabs) => {
                if (newTabs !== tabs) {
                  setTabs(newTabs);
                }
              }}
            />
          </div>
        </SubContainer>
      )}

      <SubContainer className="grid grid-cols-subgrid lg:col-start-3 lg:col-end-11">
        {loading && <SearchSkeleton />}

        {!loading && renderContent()}
      </SubContainer>

      {filteredData.length === 0 && !firstTime && (
        <SubContainer className="flex justify-center">
          <h1 className="col-span-12">{searchPage?.noRecordsFoundText || 'No records found'}</h1>
        </SubContainer>
      )}

      {loadingMore && (
        <SubContainer className="flex items-center justify-center">
          <LoadingSpin className=" col-span-12 !size-16 text-primary-500" />
        </SubContainer>
      )}

      <SubContainer className="grid grid-cols-subgrid lg:col-start-3 lg:col-end-11">
        {!loadingMore && showMoreButton && (
          <div className="col-span-4">
            <Button theme="outline" onClick={loadMoreData}>
              {searchPage?.moreBtn || '+ more'}
            </Button>
          </div>
        )}
      </SubContainer>
    </Container>
  );
};
